import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//
import { Card } from "react-bootstrap";
import Moment from "react-moment";

//
import { getCurrentMethod } from "../../../redux/features/plan/actions";
import { cancelAutoRenew } from "../../../redux/features/user/actions";

//
import ImageBox from "../../general/ImageBox";
import BoxLoading from "../../general/BoxLoading";

function CurrentMethod({ plan, cancelAutoRenew }) {
  const [loading, setLoading] = useState(false);
  const [currentMethod, setCurrentMethod] = useState({});

  const currentMethodImage = () => {
    let gateway = currentMethod.gateway;
    let bankName = currentMethod.cardInfo ? currentMethod.cardInfo.brand : "";

    if (gateway === "coinbase" || gateway === "point") return gateway;
    return bankName;
  };

  /**
   * Get Current Method
   */
  const get_current_method = async () => {
    if (plan) {
      // start loading
      setLoading(true);

      // request
      await getCurrentMethod().then((res) => {
        if (res) {
          setCurrentMethod(res);
        }
      });

      // stop loading
      setLoading(false);
    }
  };

  /**
   * Cancel Auto Renew
   */
  const cancel_auto_renew = async () => {
    // start loading
    setLoading(true);

    // request
    await cancelAutoRenew();

    // stop loading
    setLoading(false);
  };

  useEffect(() => {
    get_current_method();
  }, [plan]);

  return (
    <Card className="current-method bordered">
      <Card.Body>
        <p className="title">Your Current Payment Method</p>

        <div className="content">
          {currentMethodImage() && (
            <ImageBox
              src={
                process.env.PUBLIC_URL +
                `/creditcard-geteways/${currentMethodImage()}.png`
              }
            />
          )}

          <div className={`img-name ${!currentMethodImage() ? 'w-100' : ''}`}>
            <div className="name-number">
              <p>
                {currentMethod.gateway === "stripe"
                  ? currentMethod.cardInfo
                    ? currentMethod.cardInfo.brand
                    : "Card information not available"
                  : currentMethod.gateway}
              </p>
              {currentMethod.gateway === "stripe" && (
                <p>
                  **** **** ****{" "}
                  {currentMethod.cardInfo
                    ? currentMethod.cardInfo.last4
                    : "****"}
                </p>
              )}
            </div>

            {plan.auto_renew === "active" && (
              <p
                className="fw-extra-bolder text-danger change-method pointer"
                onClick={() => cancel_auto_renew()}
              >
                Cancel Auto Renewal
              </p>
            )}
          </div>
        </div>

        <div className="update-at">
          <i className="las la-redo-alt"></i>
          <span>
            Plan will {plan.auto_renew === "active" ? "renew" : "expire"} in{" "}
            {<Moment fromNow>{plan.expired_at}</Moment>} later
          </span>
        </div>
      </Card.Body>

      {loading && <BoxLoading />}
    </Card>
  );
}

CurrentMethod.propTypes = {
  plan: PropTypes.object.isRequired,
  cancelAutoRenew: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  cancelAutoRenew,
};

const mapStateToProps = (state) => ({
  plan: state.userReducer.plan,
});

export default connect(mapStateToProps, mapDispatchToProps)(CurrentMethod);
